<template>
  <div class="bg-secondary-1 rounded">
    <board :details="contractBoardDetails" header-class="pt-2 px-1" />
    <div class="row mx-3 pt-3 pb-3">
      <div
        class="col-12"
        :class="isTherapyCompensatoryContract ? 'col-md-3' : 'col-md-4'"
      >
        <span class="color-gray-6 d-block font-14">Servicio / Disciplina:</span>
        <span class="font-16 color-black">
          {{ serviceDisciplineName }}
        </span>
      </div>
      <div v-if="isAssistantServiceType" class="col-12 col-md-3 mt-3 mt-md-0">
        <span class="color-gray-6 d-block font-14">Jornada Diaria:</span>
        <span class="font-16 color-black">
          {{ contractInfo.workday | empty }}
        </span>
      </div>
      <div v-if="isTherapyServiceType" class="col-12 col-md-3 mt-3 mt-md-0">
        <span class="color-gray-6 d-block font-14">Frecuencia:</span>
        <span class="font-16 color-black">
          {{ contractInfo.frecuencyName | empty }}
        </span>
      </div>
      <div v-if="isTherapyServiceType" class="col-12 col-md-2 mt-3 mt-md-0">
        <span class="color-gray-6 d-block font-14">Duración:</span>
        <span class="font-16 color-black">
          {{ contractInfo.durationName | empty }}
        </span>
      </div>
      <div
        v-if="isTherapyServiceType"
        class="col-12 mt-3 mt-md-0"
        :class="isTherapyCompensatoryContract ? 'col-md-2' : 'col-md-3'"
      >
        <span class="color-gray-6 d-block font-14">Modalidad:</span>
        <span class="font-16 color-black">
          {{ contractInfo.modalityName | empty }}
        </span>
      </div>
      <div
        v-if="isTherapyCompensatoryContract"
        class="col-12 col-md-2 mt-3 mt-md-0"
      >
        <span class="color-gray-6 d-block font-14">Balance Pendiente:</span>
        <span class="font-16 color-black">
          {{ getPendingBalance }}
        </span>
      </div>
    </div>
    <div v-if="!hiddenNavigation" class="p-3">
      <contract-navigation
        ref="contractNavigationRef"
        :contract-ids="contractIds"
        :current-contract-id="currentContractId"
        :has-next-contract="hasNextContract"
        :has-previous-contract="hasPreviousContract"
        @current="changeCurrentContract"
        @next="handleNext"
        @previous="handlePrevious"
      />
    </div>
  </div>
</template>

<script>
//lib components
import Board from 'Board';
import ContractNavigation from './ContractNavigation.vue';
import { empty } from '@/filters';

export default {
  name: 'GeneralInfo',
  components: {
    Board,
    ContractNavigation,
  },
  props: {
    therapyCompensatoryBalance: {
      type: Object,
      default: () => {},
    },
    contractInfo: {
      type: Object,
      default: () => {},
    },
    hasPreviousContract: {
      type: Boolean,
      default: () => false,
    },
    hasNextContract: {
      type: Boolean,
      default: () => false,
    },
    contractIds: {
      type: Array,
      default: () => [],
    },
    isAssistantServiceType: {
      type: Boolean,
      default: () => false,
    },
    isTherapyServiceType: {
      type: Boolean,
      default: () => false,
    },
    hiddenNavigation: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    getPendingBalance() {
      return empty(this.therapyCompensatoryBalance?.pendingBalance);
    },
    isTherapyCompensatoryContract() {
      return this.contractInfo.isTherapyCompensatory;
    },
    serviceDisciplineName() {
      return this.contractInfo.disciplineTypeName
        ? `${this.contractInfo.serviceTypeName} - ${this.contractInfo.disciplineTypeName}`
        : this.contractInfo.serviceTypeName;
    },
    contractBoardDetails() {
      return [
        [
          {
            label: 'Estudiante:',
            data: this.contractInfo?.studentFullName,
            icon: 'fas fa-address-book',
            cols: 'col-12 col-md-4 w-50',
          },
          {
            label: 'Número de Contrato:',
            data: this.contractInfo?.contractNumber,
            icon: 'fas fa-address-book',
            cols: 'col-12 col-md-3 w-50',
          },
          {
            label: 'Impedimento:',
            data: this.contractInfo?.impediment,
            icon: 'fas fa-ballot-check',
            cols: 'col-12 col-md-3 w-50',
          },
          {
            label: 'Fecha de Comienzo:',
            data: this.$options.filters.date(
              this.contractInfo?.contractStartDate
            ),
            icon: 'fas fa-ballot-check',
            cols: 'col-12 col-md-2 w-50',
          },
        ],
      ];
    },
    currentContractId() {
      return this.contractInfo?.contractId;
    },
  },
  methods: {
    changeCurrentContract(id) {
      this.$emit('current', id);
    },
    handleNext() {
      this.$emit('clear-specialist-dropdown');
      this.$emit('next');
    },
    handlePrevious() {
      this.$emit('clear-specialist-dropdown');
      this.$emit('previous');
    },
  },
};
</script>
